import { swrFetcher } from "@/lib/api";
import { useAuthStore } from "@/store/auth-store";
import useSWR from "swr";

/**
 * Returns the list of class session IDs where the current user is on the waitlist.
 */
export function useUserWaitlistBookings() {
  const { isAuthenticated } = useAuthStore();

  const key = isAuthenticated
    ? "/api/widget/profile/bookings/waitlisted-session-ids"
    : null;

  const { data, error, isLoading, mutate } = useSWR<string[]>(key, swrFetcher);

  const waitlistedIds = data ?? [];

  const hasWaitlistedEvent = (classSessionId: string) => {
    return waitlistedIds.some((id) => id === classSessionId);
  };

  return {
    waitlistedIds,
    hasWaitlistedEvent,
    loading: isLoading,
    error,
    refresh: mutate,
  };
}
